import api from "./api";

import { deleteJwtToken, deleteUserSession, setJwtToken, setUserSession } from "./localstorage";
import { apiDomain } from "./constants";
import { userService } from "./user.service";

const logout = async ({ revokeToken = false } = {}) => {
  if (revokeToken) {
    await api.get(`${apiDomain}/auth/logout`, { withCredentials: true });
  }

  // remove user from local storage to log user out
  deleteUserSession();
  deleteJwtToken();
};

const CLIENT_ID_HEADER = "X-Client-ID";

const login = async (username, password) => {
  const response = await api.get(`${apiDomain}/auth/login`, {
    auth: {
      username,
      password,
    },
    headers: {
      [CLIENT_ID_HEADER]: "pgi",
    },
    withCredentials: true,
  });

  const { accessToken } = response.data;

  setJwtToken(accessToken);

  const user = {
    username: username,
    authdata: true,
    token: true, // has to be true because the application checks if it exists
  };

  setUserSession(user);

  return await userService.info();
};

const authService = {
  login,
  logout,
};

export default authService;
